/**
 * Pre-compiled fr-FR messages for ComboBox
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  clearSelection: `Effacer la sélection`,
  options: `Menu d'options`,
  selectedValues: `Valeurs sélectionnées`,
  toggleOptions: `Basculer les options`,
};
